interface GPSummaryErrorProps {
  onRetry: () => void;
}

export default function GPSummaryError({ onRetry }: GPSummaryErrorProps) {
  return (
    <div className="px-4">
      <div className="bg-white rounded-2xl border border-stone-100 shadow-sm p-8 text-center">
        <p className="text-3xl mb-4">{"\u26A0\uFE0F"}</p>
        <h3 className="text-lg font-semibold text-stone-700 mb-2">
          Unable to load your summary
        </h3>
        <p className="text-sm text-stone-500 mb-6 leading-relaxed">
          Something went wrong while generating your recovery summary. Please check your connection
          and try again.
        </p>
        <button
          onClick={onRetry}
          className="inline-flex items-center gap-2 px-6 py-3 rounded-xl text-sm font-semibold text-white transition-all hover:opacity-90 active:scale-95"
          style={{
            background: "linear-gradient(135deg,#6C7A52 0%,#C6D8A5 100%)",
          }}
        >
          Try again
        </button>
      </div>
    </div>
  );
}
